module.exports = __webpack_public_path__ + "9f8f4d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/IMG_2836@2x.png
// module id = 1021
// module chunks = 0